import styled, { css } from 'styled-components';
import { theme } from '../../../../../styles/theme';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 240px 120px auto 48px;
  column-gap: 8px;
`;

export const PredicateListContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const PredicateListIconContainer = styled.div`
  display: grid;
  grid-template-columns: 28px auto;
  column-gap: 8px;
`;

export const SimplePredicateContainerList = styled(PredicateListContainer)<{
  $showBorder?: boolean;
}>`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  ${({ $showBorder }) =>
    $showBorder &&
    css`
      border-left: 2px solid ${theme.colors.border};
      padding-left: 4px;
    `}
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 28px;
  text-align: center;
`;

export const ValueWrapper = styled.div<{
  $hasSingleValue: boolean;
  $supportCaseInsensitive: boolean;
}>`
  ${({ $hasSingleValue }) =>
    $hasSingleValue &&
    `
    width: 240px;
  `}
  ${({ $supportCaseInsensitive }) =>
    $supportCaseInsensitive &&
    `
    display: grid;
    grid-template-columns: 212px 24px;
    column-gap: 4px;
  `}
`;

export const ActionsWrapper = styled.div`
  display: flex;
  margin-top: 2px;
`;

export const PredicateListFooter = styled.div`
  display: flex;
  gap: 16px;
`;
